import React from 'react';

import {
  DataTable,
  TableHeader,
  TableBody,
  TableRow,
  TableColumn,
} from 'react-md';

const MaterialTableRow = props => {
  const { tableRowData } = props;
  return (
    <TableRow>
      { tableRowData.map( ( datum, index ) => (
        <TableColumn key={ index }>{ datum }</TableColumn>
      ) ) }
    </TableRow>
  )
}

const MaterialTable = props => {
  const { headElements, rowElements } = props;
  return (
    <DataTable plain>
      <TableHeader>
        <TableRow>
          { headElements.map( (headElement, index) => (
              <TableColumn key={ index }>{ headElement }</TableColumn>
            ))
          }
        </TableRow>
      </TableHeader>
      <TableBody>
        { rowElements.map( (rowElement, index) => (
            <MaterialTableRow tableRowData={ rowElement } key={ index }/>
          )) 
        }
      </TableBody>
    </DataTable>
  )
}

export default MaterialTable;


// WEBPACK FOOTER //
// ./src/components/MaterialTable.js